import { render, staticRenderFns } from "./SelfService.vue?vue&type=template&id=76362cbc&scoped=true"
import script from "./SelfService.vue?vue&type=script&lang=js"
export * from "./SelfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76362cbc",
  null
  
)

export default component.exports